export const InstanceActionConst: Record<string, string | number> = {
  resize: 'resize',
  upgrade: 'upgrade',
  reboot: 3,
  createSnapshot: 4,
  revertSnapshot: 5
};

export const InstanceActionName: Record<string | number, string> = {
  resize: 'Resize',
  upgrade: 'upgrade',
  4: 'Create Snapshot',
  5: 'Revert Snapshot'
};
